let page = 1, items_by_page = 6, config = null, pinsData=[],GOOGLE_MAPS_WRAPPER=null,MAP,HOTEL_PIN,GoogleMapsMarkers = [],$GoogleMaps = [], infoWindows = [];
GOOGLE_MAPS_WRAPPER = document.getElementById('js-hotels-quad__map');

//Load hotels data and Markup
function getHotels(){
  fetch(`${site_url}ajax/functions.php?operation=get_properties_map` )
  .then((resp) => resp.json() ) // Transform the data into json
  .then( (data) => {
      
      getListMarkup(data['items']);
      getAccordionMarkup(data['items']);
      LoadGoogleMaps(data['site_config'][0],data['items']);

      if(window.location.hash) {
        const hash_item = document.querySelector(window.location.hash);
        if(hash_item){
          const viewportOffset = hash_item.getBoundingClientRect();
          const topPos = viewportOffset.top;
          
          $('html,body').animate({
            scrollTop: topPos - 120
          },2000);
        }
      } else {
        // Fragment doesn't exist
      }
      
  });

}

//Hotels list markup
function hotelCardMarkup(data){
  const {fields, images} = data;
  
  
  const short_description = fields.short_description,
        button = fields.button,
        coming_soon = fields.custom3,
        map_thumbnail = images.image.no_tags[0].src,
        white_logo_url = typeof images.image.logo !== "undefined" ? images.image.logo[0].src : images.svg.logo[0].src,
        white_title_image = typeof images.image.badge !== "undefined" ? images.image.badge[0].src : images.svg.badge[0].src,
        img_alt = fields.image_title[0];

  
  let count = 0; 

  const createCard = ( button ) => {
    if( button !== "#" && button !== "" && button !== " " ) {
      return `
        <div class="hotels-quad__col animate-fade-2 top">
          <article class="hotel-item flex-layout align-items-end justify-center" id="hotel-item--${fields.entry_id}" style="background-image: url(${map_thumbnail})">
            ${(coming_soon == 'yes') ?
              `<p class="text-center hotel-item__coming">${bill_city}, ${bill_state}<br> <span>*Coming Soon</span></p>`
              :
              white_logo_url?`<img alt="${img_alt}" src="${white_logo_url}">`:''
            }
    
            <div class="hotel-item__over flex-layout align-items-center justify-center direction-col">
              ${white_title_image?`<img alt="${img_alt}" src="${white_title_image}">`:''}
              ${short_description}
              <a href="${site_url}hotels/${button}" class="btn--alt" data-title="View site" aria-label="View site hotel">View Site</a>
            </div>
          </article>
        </div>
      `;

    } else {

      return `
      <div class="hotels-quad__col animate-fade-2 top">
        <article class="hotel-item flex-layout align-items-end justify-center" id="hotel-item--${fields.entry_id}" style="background-image: url(${map_thumbnail})">
          ${(coming_soon == 'yes') ?
            `<p class="text-center hotel-item__coming">${bill_city}, ${bill_state}<br> <span>*Coming Soon</span></p>`
            :
            white_logo_url?`<img src="${white_logo_url}">`:''
          }
  
          <div class="hotel-item__over flex-layout align-items-center justify-center direction-col">
            ${white_title_image?`<img src="${white_title_image}">`:''}
            ${short_description}
          </div>
        </article>
      </div>
    `;
    }
  }

  let markup = createCard( button );
  count ++;
  return markup;

}

//Load Hotels list
function getListMarkup(obj){
  const hotels__list = document.getElementById('js-hotels-quad__list');
  Object.keys(obj).forEach(key => {
    hotels__list.innerHTML += hotelCardMarkup(obj[key]);
  });

}

//Hotels Accordion markup
function getAccordionMarkup(obj){
  const hotels__list = document.getElementById('js-hotels-quad__accordion');
  Object.keys(obj).forEach(key => {
    hotels__list.innerHTML += hotelAccordionMarkup(obj[key]);
  });
}

//Load Hotels Accordion
let accordion_content = 0;
function hotelAccordionMarkup(data){
  
  const {fields, images} = data;
  const short_description = fields.short_description,
        button = fields.button,
        coming_soon = fields.custom3,
        title = fields.title;
  
  let markup = `
    
    <article class="accordion-item ${accordion_content==0?'active':''}" data-id="${fields.entry_id}" data-key="${accordion_content}">
      <div class="accordion-item__button">
        <span class="accordion-item__city">${title}</span>
        ${(coming_soon == 'true') ? `<span class="accordion-item__coming">*Coming Soon</span>` : ''}
      </div>
      <div class="accordion-item__content">
        ${short_description}
        <a href="${site_url}hotels/${button}" class="btn2" data-title="View site" aria-label="View site hotel ${title}">View Site</a>
      </div>
    </article>
    
  `;
  accordion_content++;
  return markup;
  

}

//Close infoWindows
function closeAllInfoWindows(icon) {
  for (var i=0;i<infoWindows.length;i++) {
     infoWindows[i].close();
  }
  
  GoogleMapsMarkers.forEach(marker => {
    marker.setIcon(icon)
  });
}

//Load Google Maps
function LoadGoogleMaps(config, pins) {
  const InitializeMap = (lat, long, zoom = 13, styles) => {

    //SET POSITION OF MAP
    let PinPosition = new google.maps.LatLng(lat, long); //set longitude and latitude

    // option for google map object
    let myOptions = {
      zoom: zoom,
      center: PinPosition,
      mapTypeId: "roadmap",
      mapTypeControl: false,
      styles: (styles!='')?JSON.parse(styles):{},
      scrollwheel: false,
      disableDoubleClickZoom: false,
      backgroundColor: '#ffffff',
      panControl: false,
      zoomControl: true,
      zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
      }
    };


    // create new map make sure a DIV with id myMap exist on page
    MAP = new google.maps.Map(GOOGLE_MAPS_WRAPPER, myOptions), //generate map into div id myMap
      HOTEL_PIN = {
        id: "hotel",
        map: MAP,
        title: config.hotel_name,
        icon: config.hotel_marker_url,
        zIndex: 2,
        //animation: google.maps.Animation.BOUNCE,
        position: new google.maps.LatLng(lat, long)
      };
    // create new marker
    //new google.maps.Marker(HOTEL_PIN);
    
    let pin_id = 0;
    
    pins.forEach(key => {
      //console.log('key'+pin_id+'',key);
      let marker = loadMarker(pin_id,key,config.pin_marker_url,config.pin_marker_hover_url,MAP);
      GoogleMapsMarkers.push(marker);
      accordionAction(key,marker,pin_id,MAP,config.pin_marker_url,config.pin_marker_hover_url);
      pin_id++;
    });
    

    return $GoogleMaps = MAP;

  };

  const { latitude, longitude, zoom_map, map_styling} = config;

  InitializeMap(latitude, longitude, zoom_map, map_styling);

  
}
	

/***
 * Load marker to map
 ***/
function loadMarker(id,pin,icon,iconHover,map_selector) { //writes the marker to the map. pass a javascript object with the markers longitude latitude id and name so that the code can keep track of all the markers.  
  let {fields} = pin;
  let {title, custom1, custom2} = fields;
  const latitude = custom1;
  const longitude = custom2;
  const map_pin = icon;

  // create new marker
  let marker = new google.maps.Marker({
    id: id,
    map: map_selector,
    title: title,
    icon: map_pin,
    zIndex: 1,
    position: new google.maps.LatLng(latitude, longitude)
  });

  let nameMarkerOnHover = getPinMarkUpHover(pin);

  let nameMarkerOnHover1 = new google.maps.InfoWindow({
    content: nameMarkerOnHover
  });

  marker.addListener('mouseover', function () {
    infoWindows.push(nameMarkerOnHover1);
    closeAllInfoWindows(icon);
    nameMarkerOnHover1.open(map_selector, marker);
    marker.setIcon(iconHover);
  })

  marker.addListener('click', function () {
    let marker_id = this.id;
    $('.accordion-item').removeClass('active');
    $.each( $( ".accordion-item" ), function(index, value){
      if( $( value ).data( "key" ) == marker_id ){
          $(this).addClass('active');
      }
    })
  })

  // marker.addListener('mouseout', function () {
  //   nameMarkerOnHover1.close(map_selector, marker);
  //   marker.setIcon(icon);
  // })

  // marker.addListener('click', event => OpenLightbox(marker.id));
  // console.log(marker);
  return marker;

}

//Pin popover markup
function getPinMarkUpHover(pin) {  
  const {fields, images} = pin;
  const button = fields.button,        
        map_thumbnail = images.image.no_tags[0].src;

  const markup = `
    <div class="map-popover">
      <img src="${map_thumbnail}" alt="${fields.title}" class="img-responsive">
      <div class="flex-layout justify-between">
        <div class="map-popover__title">${fields.title}</div>
        <a href="${site_url}hotels/${button}" class="map-popover__btn btn--alt">Visit Website</a>
      </div>
    </div>
  
  `

  return markup;
}


//Accordion functionality
function accordionAction(pin_key,marker,id,map_selector,icon,iconHover){
  
  const accordion_all = document.querySelectorAll('.accordion-item');

  accordion_all[id].addEventListener('click', function(){
        
    if(accordion_all[id].classList.contains('active')){
      accordion_all[id].classList.remove('active');
    }else{
      let nameMarkerOnHover = getPinMarkUpHover(pin_key);
      let infowindow = new google.maps.InfoWindow({
        content: nameMarkerOnHover
      });
      
      infoWindows.push(infowindow);
      closeAllInfoWindows(icon);
      GoogleMapsMarkers[id].setIcon(iconHover)

      infowindow.open(map_selector, marker);
    
      var latLng = marker.getPosition();
      MAP.setCenter(latLng);

      
      for(let i = 0; i < accordion_all.length; i++){
        accordion_all[i].classList.remove('active');
      }
      accordion_all[id].classList.add('active');
    }
    
    
    
  });

  accordion_all[0].click();

}



(function(){
  const hotels = document.getElementById('hotels-quad');
  if(hotels){
    getHotels();

    document.getElementById('js-open-map').addEventListener('click', function(){
      document.querySelector('.hotels-quad__list-view').classList.remove('active');
      document.querySelector('.hotels-quad__map-view').classList.add('active');
    });

    document.getElementById('js-open-list').addEventListener('click', function(){
      document.querySelector('.hotels-quad__list-view').classList.add('active');
      document.querySelector('.hotels-quad__map-view').classList.remove('active');
    })

  }

  
  


}());